"use strict";
// packages/types/src/approvedSupplier.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierStatus = void 0;
var SupplierStatus;
(function (SupplierStatus) {
    SupplierStatus["ACTIVE"] = "active";
    SupplierStatus["INACTIVE"] = "inactive";
})(SupplierStatus || (exports.SupplierStatus = SupplierStatus = {}));
